import React from "react";
import { useStaticURL } from "tsi-common-react/src/utils/urls";

/**
 * Native ports of the three ``hc-block--jdpower-2022--banner-*`` partials.
 *
 * These versions are no longer in ``HARDCODED_CHOICES`` but their partials
 * still existed, so any persisted page that references them keeps rendering.
 * Registered by their full ``hc-block--...`` version string. Legacy
 * ``static_image`` renders EAGER under puppeteer; image ``src`` values are built
 * from the reactivated ``STATIC_URL`` context (``useStaticURL``) -- SSR-safe and
 * byte-identical to the legacy ``{% static %}`` output, unlike a Vite asset
 * import. ``height``/``width``/``class`` preserved verbatim; ``<sup>+</sup>``
 * kept adjacent to preceding text.
 */

export const JdPower2022BannerDoubleV2 = (): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <div className="hc-banner-jdpower-2022 hc-banner-jdpower-2022--double">
            <div>
                <img
                    src={`${staticURL}img/hardcoded/jdpower-2022--double--smaller-v2.png`}
                    alt="2022 JD Power Award Trophy"
                    height="153px"
                    width="145px"
                    className="hc-banner-jdpower-2022__image-double"
                    loading="lazy"
                    decoding="async"
                />
                <div>
                    <h3>#1 in Customer Satisfaction Among Mattress Brands</h3>
                    <p>
                        — Awarded by J.D. Power in 2022 & 2021<sup>+</sup>
                    </p>
                </div>
            </div>
        </div>
    );
};

export const JdPower2022BannerDouble = (): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <div className="hc-banner-jdpower-2022 hc-banner-jdpower-2022--double">
            <div>
                <img
                    src={`${staticURL}img/hardcoded/jdpower-2022--double--smaller.png`}
                    alt="2022 JD Power Award Trophy"
                    height="153px"
                    width="145px"
                    className="hc-banner-jdpower-2022__image-double"
                    loading="lazy"
                    decoding="async"
                />
                <div>
                    <h3>
                        #1 in Customer Satisfaction with Mattresses Purchased
                        Online
                    </h3>
                    <p>
                        — Awarded by J.D. Power in 2022 & 2021<sup>+</sup>
                    </p>
                </div>
            </div>
        </div>
    );
};

export const JdPower2022BannerMultiple = (): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <div className="hc-banner-jdpower-2022 hc-banner-jdpower-2022--multiple">
            <div>
                <img
                    src={`${staticURL}img/hardcoded/jdpower-2022--multiple.png`}
                    alt="2022 JD Power Award Trophy"
                    height="140px"
                    width="233px"
                    className="hc-banner-jdpower-2022__image-multiple"
                    loading="lazy"
                    decoding="async"
                />
                <div>
                    <h3>
                        {
                            "America's #1 Mattress Brand for Customer Satisfaction"
                        }
                    </h3>
                    <p>
                        Awarded by J.D. Power for Online & In-Store Mattresses
                        in 2022 & 2021<sup>+</sup>
                    </p>
                </div>
            </div>
        </div>
    );
};
